import {useSuspenseQuery} from '@apollo/client';
import {SharedEntityQuery} from '~/domains/canvas';
import {ErrorScreen} from '~/components/error-screen';
import {LoadingScreen} from '~/components/loading-screen';
import {useFeatureFlagsReady} from '~/lib/auth';
import {useDocumentTitle} from '~/lib/use-document-title';
import {Canvas} from '~/sections/canvas';

export const SharedEntity = () => {
  const {data} = useSuspenseQuery(SharedEntityQuery);
  const {entity} = data;
  const flagsReady = useFeatureFlagsReady();

  const documentTitle =
    entity.__typename === 'Canvas'
      ? `${entity.organization.name} - Continuum page`
      : 'Continuum';

  useDocumentTitle(documentTitle);

  switch (entity.__typename) {
    case 'Canvas':
      // Mounting Canvas only once flags are final means the header decision
      // is right on first paint rather than popping in after the reload.
      return flagsReady ? (
        <Canvas canvas={entity} viewerEmail={data.viewerEmail ?? null} />
      ) : (
        <LoadingScreen />
      );
    default:
      return (
        <ErrorScreen
          title="Unsupported content"
          message="This type of content is not yet supported."
        />
      );
  }
};
